import Crafting from '../../../../wttrpg/Crafting';

export default {
    GREAT_HELM: {
        name: 'Great Helm',
        DC: 19,
        craftTime: '5 Hours',
        ingredients: [
            { component: Crafting.STEEL.item, amount: 6 },
            { component: Crafting.HARDENED_LEATHER.item, amount: 3 },
            { component: Crafting.THREAD.item, amount: 6 },
            { component: Crafting.OGRE_WAX.item, amount: 2 },
            { component: Crafting.LINEN.item, amount: 1 },
        ],
        investment: 431,
        cost: 862,
    },
    HINDARSFJALL_HEAVY_ARMOR: {
        name: 'Hindarsfjall Heavy Armor',
        DC: 22,
        craftTime: '11 Hours',
        ingredients: [
            { component: Crafting.DARK_STEEL.item, amount: 4 },
            { component: Crafting.HARDENED_LEATHER.item, amount: 1 },
            { component: Crafting.BEAST_BONES.item, amount: 5 },
            { component: Crafting.THREAD.item, amount: 6 },
            { component: Crafting.DRAKE_OIL.item, amount: 1 },
        ],
        investment: 565,
        cost: 1124,
    },
    HINDARSFJALL_HEAVY_CHAUSSES: {
        name: 'Hindarsfjall Heavy Chausses',
        DC: 22,
        craftTime: '11 Hours',
        ingredients: [
            { component: Crafting.DARK_STEEL.item, amount: 3 },
            { component: Crafting.HARDENED_LEATHER.item, amount: 2 },
            { component: Crafting.LEATHER.item, amount: 1 },
            { component: Crafting.BEAST_BONES.item, amount: 5 },
            { component: Crafting.THREAD.item, amount: 8 },
            { component: Crafting.DRAKE_OIL.item, amount: 1 },
        ],
        investment: 565,
        cost: 1124,
    },
    NILFGAARDIAN_GREAVES: {
        name: 'Nilfgaardian Greaves',
        DC: 24,
        craftTime: '12 Hours',
        ingredients: [
            { component: Crafting.DARK_STEEL.item, amount: 4 },
            { component: Crafting.HARDENED_LEATHER.item, amount: 2 },
            { component: Crafting.LEATHER.item, amount: 2 },
            { component: Crafting.DARKENING_OIL.item, amount: 1 },
            { component: Crafting.DRAKE_OIL.item, amount: 1 },
            { component: Crafting.LINEN.item, amount: 1 },
            { component: Crafting.ASHES.item, amount: 10 },
        ],
        investment: 631,
        cost: 1274,
    },
    NILFGAARDIAN_HELM: {
        name: 'Nilfgaardian Helm',
        DC: 24,
        craftTime: '6 Hours',
        ingredients: [
            { component: Crafting.DARK_STEEL.item, amount: 5 },
            { component: Crafting.HARDENED_LEATHER.item, amount: 1 },
            { component: Crafting.DARKENING_OIL.item, amount: 1 },
            { component: Crafting.DRAKE_OIL.item, amount: 1 },
            { component: Crafting.ASHES.item, amount: 10 },
        ],
        investment: 600,
        cost: 1200,
    },
    NILFGAARDIAN_PAVISE: {
        name: 'Nilfgaardian Pavise',
        DC: 24,
        craftTime: '6 Hours',
        ingredients: [
            { component: Crafting.HARDENED_TIMBER.item, amount: 10 },
            { component: Crafting.HARDENED_LEATHER.item, amount: 3 },
            { component: Crafting.OGRE_WAX.item, amount: 1 },
            { component: Crafting.DARK_STEEL.item, amount: 1 },
            { component: Crafting.ESTER_GREASE.item, amount: 2 },
            { component: Crafting.DARKENING_OIL.item, amount: 1 },
            { component: Crafting.ASHES.item, amount: 10 },
            { component: Crafting.ETCHING_ACID.item, amount: 2 },
        ],
        investment: 450,
        cost: 900,
    },
    NILFGAARDIAN_PLATE_ARMOR: {
        name: 'Nilfgaardian Plate Armor',
        DC: 24,
        craftTime: '12 Hours',
        ingredients: [
            { component: Crafting.DARK_STEEL.item, amount: 5 },
            { component: Crafting.HARDENED_LEATHER.item, amount: 1 },
            { component: Crafting.LEATHER.item, amount: 1 },
            { component: Crafting.DARKENING_OIL.item, amount: 1 },
            { component: Crafting.DRAKE_OIL.item, amount: 1 },
            { component: Crafting.LINEN.item, amount: 1 },
            { component: Crafting.ASHES.item, amount: 10 },
        ],
        investment: 637,
        cost: 1274,
    },
    PAVISE: {
        name: 'Pavise',
        DC: 19,
        craftTime: '5 Hours',
        ingredients: [
            { component: Crafting.HARDENED_TIMBER.item, amount: 10 },
            { component: Crafting.HARDENED_LEATHER.item, amount: 3 },
            { component: Crafting.OGRE_WAX.item, amount: 1 },
            { component: Crafting.STEEL.item, amount: 1 },
            { component: Crafting.ESTER_GREASE.item, amount: 2 },
        ],
        investment: 378,
        cost: 750,
    },
    PLATE_GREAVES: {
        name: 'Plate Greaves',
        DC: 19,
        craftTime: '10 Hours',
        ingredients: [
            { component: Crafting.STEEL.item, amount: 5 },
            { component: Crafting.HARDENED_LEATHER.item, amount: 4 },
            { component: Crafting.THREAD.item, amount: 7 },
            { component: Crafting.ETCHING_ACID.item, amount: 4 },
            { component: Crafting.DRAKE_OIL.item, amount: 1 },
            { component: Crafting.OGRE_WAX.item, amount: 1 },
        ],
        investment: 468,
        cost: 798,
    },
    PLATE_ARMOR: {
        name: 'Plate Armor',
        DC: 19,
        craftTime: '10 Hours',
        ingredients: [
            { component: Crafting.STEEL.item, amount: 6 },
            { component: Crafting.HARDENED_LEATHER.item, amount: 3 },
            { component: Crafting.THREAD.item, amount: 7 },
            { component: Crafting.ETCHING_ACID.item, amount: 4 },
            { component: Crafting.DRAKE_OIL.item, amount: 1 },
            { component: Crafting.OGRE_WAX.item, amount: 1 },
        ],
        investment: 468,
        cost: 937,
    },
    SKELLIGE_HELM: {
        name: 'Skellige Helm',
        DC: 22,
        craftTime: '6 Hours',
        ingredients: [
            { component: Crafting.DARK_STEEL.item, amount: 4 },
            { component: Crafting.HARDENED_LEATHER.item, amount: 2 },
            { component: Crafting.BEAST_BONES.item, amount: 5 },
            { component: Crafting.THREAD.item, amount: 6 },
            { component: Crafting.DRAKE_OIL.item, amount: 1 },
        ],
        investment: 527,
        cost: 1050,
    },
}

// {
//     name: '',
//     DC: 22,
//     craftTime: '6 Hours',
//     ingredients: [
//         { component: Crafting..item, amount: 1 },
//         { component: Crafting..item, amount: 2 },
//     ],
//     investment: ,
//     cost: ,
// },